export default __webpack_public_path__ + "media/images/features/hida/title-right-aab1d408e72d1e204cec0ba5d1e7442d.png";